const tags = [
    {
        title: {
            no: 'Snøscooter',
            en: 'Snowmobile',
        },
        value: 'snow_mobile'
    },
    {
        title: {
            no: 'Nordlys',
            en: 'Northern lights',
        },
        value: 'northern_lights'
    },
    {
        title: {
            no: 'Hundeslede',
            en: 'Dog Sledding',
        },
        value: 'dog_sleigh'
    },
    {
        title: {
            no: 'Senior',
            en: 'Senior',
        },
        value: 'senior'
    },
    {
        title: {
            no: 'Diverse',
            en: 'Miscellaneous',
        },
        value: 'diverse'
    },
    {
        title: {
            no: 'Båttur',
            en: 'Boat trip',
        },
        value: 'boat'
    },
    {
        title: {
            no: 'ATV',
            en: 'ATV',
        },
        value: 'atv'
    },
    {
        title: {
            no: 'Smak',
            en: 'Taste',
        },
        value: 'taste'
    },
    {
        title: {
            no: 'Historie',
            en: 'History',
        },
        value: 'history'
    },
    {
        title: {
            no: 'Isgrotte',
            en: 'Ice cave',
        },
        value: 'ice_cave'
    },
    {
        title: {
            no: 'Fottur',
            en: 'Hiking',
        },
        value: 'hiking'
    },
]

export default tags;